import { differenceInMinutes } from "date-fns";
import type { WeekAppointment } from "@/lib/dashboard-week";

export { idadeEmAnos } from "@/lib/nascimento";

const emMinutos = (hhmm: string) => {
  const [h, m] = hhmm.split(":").map(Number);
  return Number.isFinite(h) && Number.isFinite(m) ? h * 60 + m : null;
};

/** Duração AGENDADA (startTime→endTime) — a previsão, não o que aconteceu. */
export function duracaoAgendada(appt: Pick<WeekAppointment, "startTime" | "endTime">): string {
  const de = emMinutos(appt.startTime);
  const ate = emMinutos(appt.endTime);
  if (de === null || ate === null || ate <= de) return "";
  return formatarMinutos(ate - de);
}

/** A mesma duração por extenso — no cartão o espaço pede "30 min", no diálogo cabe "30 minutos". */
export function duracaoAgendadaPorExtenso(
  appt: Pick<WeekAppointment, "startTime" | "endTime">,
): string {
  const de = emMinutos(appt.startTime);
  const ate = emMinutos(appt.endTime);
  if (de === null || ate === null || ate <= de) return "";
  const total = ate - de;
  if (total < 60) return `${total} ${total === 1 ? "minuto" : "minutos"}`;
  const h = Math.floor(total / 60);
  const m = total % 60;
  const horas = `${h} ${h === 1 ? "hora" : "horas"}`;
  return m === 0 ? horas : `${horas} e ${m} min`;
}

/**
 * Tempo REAL do atendimento, a partir de `startedAt`/`finishedAt` — o que "Iniciar atendimento"
 * carimbou, não o horário agendado. Em curso conta a partir de agora; encerrado mostra o total.
 * Devolve string vazia quando a consulta nem começou, que é o caso mais comum na lista do dia.
 */
export function tempoDeAtendimento(appt: Pick<WeekAppointment, "startedAt" | "finishedAt">): string {
  if (!appt.startedAt) return "";
  const inicio = new Date(appt.startedAt);
  if (appt.finishedAt) {
    const total = differenceInMinutes(new Date(appt.finishedAt), inicio);
    return total >= 0 ? `Duração: ${formatarMinutos(total)}` : "";
  }
  const corrido = differenceInMinutes(new Date(), inicio);
  return corrido >= 0 ? `Em curso: ${formatarMinutos(corrido)}` : "";
}

function formatarMinutos(total: number): string {
  if (total < 60) return `${total} min`;
  const h = Math.floor(total / 60);
  const m = total % 60;
  return m === 0 ? `${h}h` : `${h}h${String(m).padStart(2, "0")}`;
}
